module.exports = __webpack_public_path__ + "static/media/pencil.7d6146fd.svg";